import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Flower2, Calendar, BookOpen, Download } from 'lucide-react';
export function Hero() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const badges = [{
    Icon: Flower2,
    text: '60+ clases listas para usar'
  }, {
    Icon: Calendar,
    text: '100+ secuencias profesionales'
  }, {
    Icon: BookOpen,
    text: 'Recursos imprimibles'
  }, {
    Icon: Download,
    text: 'Acceso inmediato'
  }];
  return <section className="relative pt-5 pb-10 sm:pt-8 sm:pb-14 lg:pt-12 lg:pb-20 overflow-hidden" style={{
    background: 'radial-gradient(120% 90% at 50% 20%, #FFFDF8 0%, #FAF8F5 48%, #F1EBE0 100%)'
  }} data-id="element-93">
      <div className="absolute top-20 left-1/2 -translate-x-1/2 w-[900px] h-[900px] bg-[#FBEFD8] rounded-full blur-[140px] opacity-70 pointer-events-none" data-id="element-94" />
      <div className="absolute -top-24 -left-28 w-[430px] h-[430px] bg-[#9CB58E] rounded-full blur-[100px] opacity-20 pointer-events-none" data-id="element-95" />
      <div className="absolute top-20 -right-24 w-[420px] h-[420px] bg-[#9CB58E] rounded-full blur-[100px] opacity-20 pointer-events-none" data-id="element-96" />
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[700px] h-[300px] bg-[#D6A15D] rounded-full blur-[120px] opacity-10 pointer-events-none" data-id="element-97" />

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-98">
        <motion.div initial={{
        opacity: 0,
        y: 18
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.55
      }} data-id="element-99">
          <div className="inline-flex items-center gap-1.5 px-4 py-1.5 rounded-full bg-brand-50/80 text-brand-700 font-medium text-[10px] sm:text-xs uppercase tracking-widest mb-4 sm:mb-6 border border-brand-100/60 backdrop-blur-sm" data-id="element-100">
            🧘 Para profesores de Yoga
          </div>

          <h1 className="text-[34px] sm:text-5xl lg:text-7xl font-serif font-medium text-ink-900 leading-[1.05] mb-5 tracking-tight max-w-4xl mx-auto" data-id="element-101">
            Resolvé todo tu{' '}
            <span className="text-brand-600 italic" data-id="element-102">año de Yoga</span> en 5
            minutos
          </h1>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96,
        y: 16
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} transition={{
        duration: 0.7,
        delay: 0.15
      }} className="relative mb-5 sm:mb-7 mt-3 sm:mt-5 max-w-[330px] sm:max-w-xl lg:max-w-3xl mx-auto" data-id="element-103">
          <div className="absolute inset-0 rounded-[28px] sm:rounded-[36px] bg-[#F8F4EE]/90 border border-white/70 shadow-[0_24px_70px_rgba(14,59,67,0.11)]" data-id="element-104" />
          <div className="absolute inset-x-8 top-1/2 -translate-y-1/2 h-[65%] rounded-full bg-[#D6A15D]/20 blur-[60px] pointer-events-none" data-id="element-105" />
          <div className="absolute inset-x-10 bottom-0 h-[40%] rounded-full bg-brand-600/10 blur-[70px] pointer-events-none" data-id="element-106" />

          <div className="relative z-10 p-2.5 sm:p-5 lg:p-7" data-id="element-107">
            <img src="https://cdn.magicpatterns.com/uploads/uMGLHkrAEDEWbGsnuzdenp/Mockup_yoga.png" alt="Mega Pack Yoga Listo 2026 — 6 tomos completos y 6 bonos exclusivos" className="w-full h-auto object-contain rounded-[22px] sm:rounded-[28px]" data-id="element-108" />
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 14
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.55,
        delay: 0.25
      }} data-id="element-109">
          <p className="text-sm sm:text-base lg:text-lg text-ink-600 mb-5 leading-relaxed max-w-2xl mx-auto font-light" data-id="element-110">
            6 tomos, 6 bonos y todo el material listo para planificar clases,
            crear secuencias y acompañar alumnos durante todo el año.
          </p>

          <button onClick={scrollToPricing} className="group w-full sm:w-auto bg-brand-700 hover:bg-brand-800 text-white text-base sm:text-lg font-medium py-4 sm:py-5 px-8 sm:px-10 rounded-full shadow-[0_14px_35px_rgba(14,59,67,0.22)] hover:shadow-[0_18px_45px_rgba(14,59,67,0.28)] transition-all transform hover:-translate-y-0.5 inline-flex items-center justify-center gap-3 tracking-wide" data-id="element-111">
            QUIERO ACCEDER AHORA
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-112" />
          </button>

          <p className="mt-3 text-xs sm:text-sm text-ink-400 font-medium tracking-wide" data-id="element-113">
            🔒 Pago 100% seguro · Garantía de 7 días
          </p>

          <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 mt-8 sm:mt-10 max-w-4xl mx-auto" data-id="element-114">
            {badges.map((b, i) => {
            const Icon = b.Icon;
            return <div key={i} className="flex items-center gap-3 text-xs sm:text-sm font-medium text-ink-700 bg-white/65 backdrop-blur-sm border border-brand-100/40 px-4 py-3 rounded-2xl shadow-sm" data-id="element-115">
                  <div className="w-8 h-8 rounded-full bg-brand-50 text-brand-600 flex items-center justify-center shrink-0" data-id="element-116">
                    <Icon className="w-4 h-4" strokeWidth={1.5} data-id="element-117" />
                  </div>
                  <span className="text-left leading-snug" data-id="element-118">{b.text}</span>
                </div>;
          })}
          </div>
        </motion.div>
      </div>
    </section>;
}